import { render, staticRenderFns } from "./GrantReportToUser.vue?vue&type=template&id=530a2af0&"
import script from "./GrantReportToUser.vue?vue&type=script&lang=js&"
export * from "./GrantReportToUser.vue?vue&type=script&lang=js&"
import style0 from "./GrantReportToUser.vue?vue&type=style&index=0&id=530a2af0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports